import { LoadingOutlined } from '@ant-design/icons'
import { useStore } from '@nanostores/react'
import { Modal, Spin } from 'antd'

import { $openModalProcess, $titleProcessing } from 'stores/modal.store'

const ModalProcess = () => {
  const openModalProcess = useStore($openModalProcess)
  const title = useStore($titleProcessing)

  if (!openModalProcess) return null

  return (
    <Modal
      title={title || null}
      open
      footer={null}
      closable={false}
      maskClosable={false}
      wrapClassName="modal-confirm"
      centered
    >
      <div className="spin-stake">
        <Spin size="large" indicator={<LoadingOutlined style={{ fontSize: 60 }} spin />} />
      </div>
      <p className="modal-text1">Your request is being processed. Please wait...</p>
    </Modal>
  )
}

export default ModalProcess
